import { createConversionEventId } from './conversionEventId'

// Meta's half of the pixel ↔ Conversions API deduplication, see
// conversionEventId.

const slot = createConversionEventId('arena_fb_event_id')

export const newFbEventId = slot.mint
export const consumeFbEventId = slot.consume
